import { useState, useEffect } from "react";

const CACHE_KEY = "sbdb_studies_v1";
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

function getCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw);
    if (Date.now() - ts > CACHE_TTL) return null;
    return data;
  } catch {
    return null;
  }
}

function setCache(data) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data, ts: Date.now() }));
  } catch {}
}

export function useStudies() {
  const [studies, setStudies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cached = getCache();
    if (cached) {
      setStudies(cached);
      setLoading(false);
      return;
    }
    fetch("/api/studies")
      .then((r) => r.json())
      .then((data) => {
        setCache(data);
        setStudies(data);
      })
      .catch((e) => console.error("Error fetching studies:", e))
      .finally(() => setLoading(false));
  }, []);

  return { studies, loading };
}
